import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TabBoxItemConverter extends CmsConverterService<TabBoxItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      // TODO: Spartacus Upgrade - @Michael Latta
      // label: formData.st_label ?? doNotTrack,
      label: formData.st_label ?? '',
      tabContentLeft: formData.st_header_left ?? defaultFSCatalog,
      tabContentRight: formData.st_header_right_text ?? defaultTextInput,
      content: formData.st_items ?? defaultFSCatalog
    }
  }
}

export const TAB_BOX_ITEM_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TabBoxItemData>>('TabBoxItemConverter')

export interface TabBoxItemData extends ConvertedComponentData {
  label: TextInput;
  tabContentLeft: FsCatalog;
  tabContentRight: TextInput;
  content: FsCatalog;
}
